<template>
  <div :class="divPadding" class="flex items-center">
    <img :src="logo" alt="icon" class="h-8 w-auto mr-4" />
    <div :class="textClass" class="inline-block text-xl font-semibold uppercase">
      {{ name }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'logo',
  props: {
    divPadding: {
      type: String,
      default: 'px-4',
      required: false,
    },
    textClass: {
      type: String,
      default: 'text-white text-xs',
      required: false,
    },
  },
  computed: {
    name() {
      return this.$store.getters['app/getAppName'];
    },
    logo() {
      return this.$store.getters['app/getAppLogo'];
    },
  },
};
</script>
